export const notAuthenticatedError = new Error('Not authenticated');
//# sourceMappingURL=errors.js.map